'use client';

import { HStack, VStack } from '@terra/ui-styled-system';
import { Badge } from '../../../../../components/badge';
import { Text } from '../../../../../components/styled/text';
import type { ParsedAdRelationship } from './parse-ad-relationships-output.util';

export function AdRelationshipsListBody({
  relationships,
}: {
  relationships: ParsedAdRelationship[];
}) {
  return (
    <VStack alignItems="stretch" gap={1.25} width="100%" overflowX="hidden">
      {relationships.map((relationship, index) => (
        <HStack
          key={`${relationship.peerNodeId}-${relationship.relationshipType}-${index}`}
          gap={1.5}
          alignItems="center"
        >
          <Badge size="sm" variant="emphasis">
            {relationship.direction}
          </Badge>
          <Text fontSize="xs" color="fg.default" truncate flex={1}>
            {relationship.relationshipType}
            {relationship.isAbusable ? ' · abusable' : ''} →{' '}
            {relationship.peerDisplayName}
          </Text>
          <Text fontSize="2xs" color="fg.muted" fontFamily="mono" truncate>
            {relationship.peerNodeId}
          </Text>
        </HStack>
      ))}
    </VStack>
  );
}
